import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { txApis } from "./tx-apis";

interface TxState {
  txs: TxReportingData[];
  tx: TxReportingData | null;
  aggTx: TransactionAggregationData[];
  dailyAggTx: DailyTransactionAggregationData[];
}

const initialState: TxState = {
  txs: [],
  tx: null,
  aggTx: [],
  dailyAggTx: [],
};

const txSlice = createSlice({
  name: "txSlice",
  initialState,
  reducers: {
    setTxs: (state, action: PayloadAction<TxReportingData[]>) => {
      state.txs = action.payload;
    },
    setTx: (state, action: PayloadAction<TxReportingData>) => {
      state.tx = action.payload;
    },
    setAggTx: (state, action: PayloadAction<TransactionAggregationData[]>) => {
      state.aggTx = action.payload;
    },
    setDailyAggTx: (
      state,
      action: PayloadAction<DailyTransactionAggregationData[]>
    ) => {
      state.dailyAggTx = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        txApis.endpoints.getAggTxReport.matchFulfilled,
        (state, action) => {
          state.aggTx = action.payload;
        }
      )
      .addMatcher(
        txApis.endpoints.getDailyAggReport.matchFulfilled,
        (state, action) => {
          state.dailyAggTx = action.payload;
        }
      );
  },
});

export const txActions = txSlice.actions;
export default txSlice.reducer;
